import { ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy } from '@angular/router';
import { Injectable } from '@angular/core';

@Injectable()
export class RouteReuseService implements RouteReuseStrategy {
    private storedRoutes = new Map<string, DetachedRouteHandle>();

    public retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
        const routeKey = this.getRouteKey(route);
        if (!routeKey || !this.storedRoutes.has(routeKey)) {
            return null;
        }
        return this.storedRoutes.get(routeKey) || null;
    }

    public shouldAttach(route: ActivatedRouteSnapshot): boolean {
        const routeKey = this.getRouteKey(route);
        const shouldAttach = !!routeKey && this.storedRoutes.has(routeKey);
        return shouldAttach;
    }

    public shouldDetach(route: ActivatedRouteSnapshot): boolean {
        const routeKey = this.getRouteKey(route);
        const isTreeRoute = routeKey?.includes('tree') || false;
        return isTreeRoute;
    }

    public shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
        return future.routeConfig === curr.routeConfig;
    }

    public store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {
        const routeKey = this.getRouteKey(route);
        if (routeKey) {
            this.storedRoutes.set(routeKey, handle);
        }
    }

    private getRouteKey(route: ActivatedRouteSnapshot): string | null {
        if (!route.routeConfig) {
            return null;
        }

        let path = route.routeConfig.path || '';
        let currentRoute = route;

        while (currentRoute.parent) {
            currentRoute = currentRoute.parent;
            if (currentRoute.routeConfig?.path) {
                path = `${currentRoute.routeConfig.path}/${path}`;
            }
        }

        return path;
    }
}
